<color-picker>
  <div data-pickr></div>
  <script>
    import Pickr from '@simonwep/pickr';
    const defaultOption = {
      theme: 'nano',
      swatches: [
        '#d5ffd5', '#d5eaff', '#d5d5ff', '#ffffd5', '#faeee0', '#ffd5d5', '#ffe5ff', '#ffffff',
        '#bfff7f', '#ccf2f4', '#9AB3F5', '#ffff89', '#f9cf93', '#ffadad', '#ffd1ff', '#dddddd',
        '#80ff80', '#aaffff', '#80bfff', '#fff338', '#fdb87d', '#ff8080', '#ffb2ff', '#e2e2e2',
        '#6aa84f', '#45818e', '#3d85c6', '#f1c232', '#e69138', '#cc0000', '#a64d79', '#bfbfbf',
        '#38761d', '#134f5c', '#0b5394', '#bf9000', '#b45f06', '#990000', '#741b47', '#7f7f7f',
        '#00ff00', '#00ffff', '#0000ff', '#ffff00', '#ff9900', '#ff0000', '#ff93ff', '#000000',
      ],
      components: {
        palette: false,
        preview: false,
        hue: false,
        interaction: {
          input: false,
          save: false,
          cancel: false,
          rgba: false,
        }
      },
    };

    export default {
      pickr: null,

      onMounted() {
        this.pickr = Pickr.create({
          el: this.$('[data-pickr]'),
          default: this.props.value || '',
          ...defaultOption,
          ...this.props.option
        });

        this.pickr
          .on('swatchselect', () => {
            this.pickr.applyColor(false);
          })
          .on('save', (color) => {
            this.pickr.hide();
            this.props.onChange?.(color?.toHEXA().toString(0) || '');
          })
          .on('cancel', () => {
            this.pickr.hide();
          });
      },

      onBeforeUpdate() {
        if (this.props.hasOwnProperty('value')) {
          this.pickr.setColor(this.props.value || 'rgba(0, 0, 0, 0)', true);
          this.pickr.applyColor(true);
        }
      },

      onBeforeUnmount() {
        if (this.pickr) {
          this.pickr.destroyAndRemove();
          this.pickr = null;
        }
      }
    };
  </script>
  <style>
    .pcr-button {
      border: 1px solid rgba(0, 0, 0, 0.8);
    }
  </style>
</color-picker>